import { Trans } from '@lingui/react'
import { type FunctionComponent, useEffect, useState } from 'react'

import PreQueryListItem from './PreQueryListItem'
import { type SearchHit } from './types'

type ComponentProps = {
  hits: SearchHit[]
  mobile?: boolean
}

const useUpAndDownKeys = (items: SearchHit[]) => {
  const [selectedIndex, setselectedIndex] = useState(-1)
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'ArrowDown') {
        setselectedIndex((selectedIndex + 1) % items.length)
      } else if (event.key === 'ArrowUp') {
        setselectedIndex(
          selectedIndex <= 0 ? items.length - 1 : selectedIndex - 1
        )
      } else if (event.key === 'Enter' && items[selectedIndex].deeplink) {
        window.location.href = items[selectedIndex].deeplink
      }
    }
    document.addEventListener('keydown', handleKeyDown)
    return () => {
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [items, selectedIndex])

  return selectedIndex
}
const TopProducts: FunctionComponent<ComponentProps> = ({ mobile, hits }) => {
  const selectedIndex = useUpAndDownKeys(hits)

  return (
    <div className="u-padding u-padding-x-small--bottom o-SearchBox__top-product">
      <div className="o-SearchBox__top-searches-product__title u-font-weight--bold">
        <Trans id="searchBox.label.popularProducts" />
      </div>
      <ul className="a-list-reset o-SearchBox__list u-padding--top a">
        {hits.map((hit, index) => (
          <PreQueryListItem
            mobile={mobile}
            key={hit.id}
            item={hit}
            last={index + 1 === hits.length}
            position={index + 1}
            selected={selectedIndex === index}
          />
        ))}
      </ul>
    </div>
  )
}

export default TopProducts
